const timezoneKeys = {
    all: () => [{ entity: 'timezone' }],
    allLists: () => [{ ...timezoneKeys.all()[0], scope: 'list' }],
    list: () => [{ ...timezoneKeys.allLists()[0] }],
};

export default timezoneKeys;
